// Picks up an image that was "shared to" the app via the PWA share target.
//
// The service worker (sw.ts) intercepts the share POST, stashes the file in the
// Cache API under a fixed URL, then redirects here with ?shared=1. On startup we
// look for that flag, pull the file back out, and hand it to the store.

import { SHARE_CACHE, SHARED_URL } from "../constants.js";

/** If we were opened as a share target, load the shared image and return true. */
export async function consumeSharedImage(): Promise<Blob | null> {
  const params = new URLSearchParams(location.search);
  if (!params.has("shared")) return null;

  // Clean the URL so a refresh doesn't re-trigger.
  history.replaceState(null, "", location.pathname);

  try {
    const cache = await caches.open(SHARE_CACHE);
    const res = await cache.match(SHARED_URL);
    if (!res) return null;
    const blob = await res.blob();
    await cache.delete(SHARED_URL);
    if (blob && blob.size > 0) return blob;
  } catch {
    // Cache unavailable (e.g. private mode) — nothing to load.
  }
  return null;
}
